import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=48cb7b54&"
import script from "./MessageReply.vue?vue&type=script&lang=js&"
export * from "./MessageReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports